import locales from '@locales';
import { PersistPartial } from 'redux-persist/es/persistReducer';

const LOCALE_STORAGE_KEY = '_wl'; // Wolf Locale

export const LocaleTypes = {
  SET_LOCALE: 'SET_LOCALE',
};

export const setLocale = (locale: string) => {
  try {
    localStorage.setItem(LOCALE_STORAGE_KEY, locale);
  } catch (e) {
    // Silent fail - localStorage may not be available
  }

  return {
    type: LocaleTypes.SET_LOCALE,
    data: locale,
  };
};

export type LocaleState = {
  activeLocale: string;
  locale: { [key: string]: any };
} & PersistPartial;

// Get initial language - check localStorage first, then browser language
const getInitialLanguage = (): string => {
  try {
    const savedLocale = localStorage.getItem(LOCALE_STORAGE_KEY);
    if (savedLocale && ['en', 'es'].includes(savedLocale)) {
      return savedLocale;
    }
  } catch (e) {
    // Silent fail - localStorage may not be available
  }

  // Fallback to browser language
  const browserLang = navigator.language.split('-')[0];
  return ['en', 'es'].includes(browserLang) ? browserLang : 'en';
};

// INITIAL STATE
const initialLanguage: string = getInitialLanguage();

const localeInitialState: LocaleState & PersistPartial = {
  activeLocale: initialLanguage,
  locale: {
    ...(locales as { [key: string]: any })[initialLanguage],
  },
  _persist: {
    version: 0,
    rehydrated: false,
  },
};

export type LocaleAction = {
  type: string;
  data: string;
};

const localeReducer = (state = localeInitialState, action: LocaleAction | any) => {
  switch (action.type) {
    case LocaleTypes.SET_LOCALE:
      return {
        ...state,
        activeLocale: action.data,
        locale: (locales as { [key: string]: any })[action.data],
      };

    default:
      return state;
  }
};

export default localeReducer;
